import { useSelector } from 'react-redux';

import { useVary } from '@swf/components/ResponseHeaders/ResponseHeaders';
import { Header } from '@swf/core/enums';
import { select } from '@swf/core/store';

interface TimeZone {
  timeZone: string;
  timeZoneName: string;
}

const useTimeZone = (): TimeZone => {
  useVary({ by: [Header.TimeZone] });
  const timeZoneName = useSelector(select.timeZone.getTimeZoneName);
  const timeZone = useSelector(select.timeZone.getTimeZone);

  return { timeZone, timeZoneName };
};

export default useTimeZone;
